import { Box, Text, Flex, Image, VStack } from '@chakra-ui/react'
import { useTranslations } from 'next-intl'

import { CheckIconWithBg } from '@/components/icons/CheckIconWithBg'

export function LoginOptIn() {
  const t = useTranslations()

  const accountFeaturesText = [
    {
      id: 1,
      bullet: t('auth.sign-in.buy-hardware'),
    },
    {
      id: 2,
      bullet: t('auth.sign-in.pay-hosting'),
    },
    {
      id: 3,
      bullet: t('auth.sign-in.check-status'),
    },
    {
      id: 4,
      bullet: t('auth.sign-in.pool-account'),
    },
  ]

  return (
    <Flex
      bg="black.300"
      width={{ base: '100%', lg: '43%' }}
      height={{ base: 'auto', lg: '760px' }}
      borderTopLeftRadius="16px"
      direction="column"
      justify="center"
      mt={16}
      position={'relative'}
      padding={{ base: '50px 30px 0 30px', md: '44px', xl: '54px 64px' }}
    >
      <VStack
        spacing={{ sm: 2, base: 0 }}
        align={'flex-start'}
        w={'auto'}
        color={'white'}
        height="100%"
      >
        <Text fontSize="24px" fontWeight="semibold">
          {t('auth.sign-in.account-features')}:
        </Text>
        <VStack align={'flex-start'} pl={'5'}>
          {accountFeaturesText.map((item) => (
            <Text fontSize="17px" key={item.id}>
              {
                <CheckIconWithBg
                  rounded={'md'}
                  mr={'3'}
                  w={{ sm: '8', base: '5' }}
                  h={{ sm: '8', base: '5' }}
                  justifySelf={'center'}
                />
              }
              {item.bullet}
            </Text>
          ))}
        </VStack>
      </VStack>
      <Box
        position={{ base: 'static', lg: 'absolute' }}
        bottom="0"
        left={{ base: '0', lg: '-18%', '2xl': '-14%' }}
        width={{ base: '100%', lg: '624px' }}
        mt={{ base: 10, lg: 0 }}
      >
        <Image
          height="100%"
          width="100%"
          objectFit="contain"
          src="/img/login-page-image.png"
          alt="Account Features displaying Compass Mining Wallet dashboard"
        />
      </Box>
    </Flex>
  )
}
